var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: { loading: _vm.loading, color: _vm.$constants.LOADING_COLOR },
      }),
      _vm._v(" "),
      !_vm.loading && _vm.localDrug
        ? [
            _vm.drugHasDetail("orderRates")
              ? _c("div", { staticClass: "alert alert-info text-center" }, [
                  (_vm.drugDetails?.suppliers_data?.order_rate?.value ?? 0) > 1
                    ? _c("h5", [
                        _vm._v(
                          "ЭТОТ ПРЕПАРАТ ИМЕЕТ КОЭФИЦИЕНТ ЗАКУПКИ -\n        ЗАКУПАЕМ ТОЛЬКО КРАТНО " +
                            _vm._s(
                              _vm.drugDetails.suppliers_data.order_rate.value
                            )
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  (_vm.drugDetails?.suppliers_data?.oposit_order_rate?.value ??
                    0) > 1
                    ? _c("h5", [
                        _vm._v(
                          'ЭТОТ ПРЕПАРАТ ИМЕЕТ ФАСОВКУ ЗАКУПКИ\n        БЛИСТЕРОВ (ЗАКУПАЕМ ПО "БЛИСТЕРНО": НАША ЦЕНА / ' +
                            _vm._s(
                              _vm.drugDetails.suppliers_data.oposit_order_rate
                                .value
                            ) +
                            " -\n        ЦЕНА БЛИСТЕРА)"
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "form",
              {
                attrs: { action: "" },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.createOrder.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "text-left" },
                  [
                    _vm.ordered.length
                      ? _c("OrderedInvoices", {
                          attrs: {
                            orders: _vm.ordered,
                            costPrice: _vm.costPrice,
                            suppliers: _vm.suppliers,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "text-left" }),
                _vm._v(" "),
                _c(
                  "table",
                  { staticClass: "table table-hover table-sm mt-1" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        _vm._l(
                          _vm.getSortedOrders(),
                          function (orders, cId_text) {
                            return [
                              _c("tr", { staticClass: "country_tr" }, [
                                _c("td", { attrs: { colspan: "20" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$AllCountries[orders.country_id].name
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm._l(orders.orders, function (o) {
                                return _c(
                                  "tr",
                                  {
                                    class: {
                                      ordered: o.ordered,
                                      parse_store_out: _vm.isDrugOutOfStore(o),
                                    },
                                  },
                                  [
                                    !o.toDelete
                                      ? [
                                          _c("td", [
                                            o.ordered
                                              ? _c("i", {
                                                  staticClass:
                                                    "icon-fa icon-fa-check-circle",
                                                })
                                              : _vm._e(),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: o.supplier.id,
                                                    expression: "o.supplier.id",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                attrs: { disabled: "" },
                                                on: {
                                                  change: function ($event) {
                                                    var $$selectedVal =
                                                      Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function (o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function (o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                    _vm.$set(
                                                      o.supplier,
                                                      "id",
                                                      $event.target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    )
                                                  },
                                                },
                                              },
                                              _vm._l(
                                                _vm.suppliers,
                                                function (s) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      domProps: { value: s.id },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(s.title) +
                                                          "\n                    (" +
                                                          _vm._s(
                                                            _vm.$AllCountries[
                                                              s.country_id
                                                            ] &&
                                                              _vm.$AllCountries[
                                                                s.country_id
                                                              ].title
                                                          ) +
                                                          ")\n                    "
                                                      ),
                                                      _vm.drugPrices &&
                                                      _vm.drugPrices[s.id]
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.printDate(
                                                                  _vm
                                                                    .drugPrices[
                                                                    s.id
                                                                  ].updated_at,
                                                                  "DD/MM"
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm._e(),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            [
                                              _vm._l(
                                                _vm.drugPrices[o.supplier.id],
                                                function (dp) {
                                                  return dp.link
                                                    ? [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "flex flex_gap_5 mb-1",
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "mr-1",
                                                                attrs: {
                                                                  href: `${dp.link}`,
                                                                  target:
                                                                    "_blank",
                                                                },
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "icon-fa icon-fa-globe",
                                                                }),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "v-popover",
                                                              {
                                                                attrs: {
                                                                  popoverClass:
                                                                    "_in_modal",
                                                                  placement:
                                                                    "right",
                                                                  trigger:
                                                                    "hover",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    class: {
                                                                      badge: true,
                                                                      [_vm.getPriceStatus(
                                                                        dp
                                                                      )
                                                                        .class]: true,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "pointer icon-fa icon-fa-info",
                                                                    }),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "template",
                                                                  {
                                                                    slot: "popover",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                        " +
                                                                        _vm._s(
                                                                          _vm.getPriceStatus(
                                                                            dp
                                                                          )
                                                                            .statusTitle
                                                                        ) +
                                                                        "\n                      "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              2
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "badge badge-dark pointer",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.setSupplierPrice(
                                                                        o
                                                                          .supplier
                                                                          .id,
                                                                        dp.price
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    dp.price
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(dp.pzn)
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            dp.updated_at
                                                              ? _c(
                                                                  "v-popover",
                                                                  {
                                                                    attrs: {
                                                                      popoverClass:
                                                                        "_in_modal",
                                                                      placement:
                                                                        "right",
                                                                      trigger:
                                                                        "hover",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "pointer icon-fa icon-fa-clock-o",
                                                                    }),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "template",
                                                                      {
                                                                        slot: "popover",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                        " +
                                                                            _vm._s(
                                                                              _vm.printDate(
                                                                                dp.updated_at
                                                                              )
                                                                            ) +
                                                                            "\n                      "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  2
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            dp?.error
                                                              ? _c(
                                                                  "v-popover",
                                                                  {
                                                                    attrs: {
                                                                      popoverClass:
                                                                        "_in_modal",
                                                                      placement:
                                                                        "right",
                                                                      trigger:
                                                                        "hover",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "color_dark_red pointer icon-fa icon-fa-warning",
                                                                    }),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "template",
                                                                      {
                                                                        slot: "popover",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                        " +
                                                                            _vm._s(
                                                                              dp.error
                                                                            ) +
                                                                            "\n                      "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  2
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    : _vm._e()
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.getSupplierDiscount(
                                                      o.supplier.id
                                                    )
                                                  ) +
                                                  "\n              "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: o.price,
                                                  expression: "o.price",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              domProps: { value: o.price },
                                              on: {
                                                change: function ($event) {
                                                  o.toUpdateManualPrice = true
                                                },
                                                keyup: function ($event) {
                                                  return _vm.updatePriceDecimal(
                                                    o
                                                  )
                                                },
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    o,
                                                    "price",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c("input", {
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "number",
                                                disabled: "",
                                              },
                                              domProps: {
                                                value: _vm.discountedPrice(o),
                                              },
                                            }),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: o.qty,
                                                  expression: "o.qty",
                                                },
                                              ],
                                              ref: "newQty",
                                              refInFor: true,
                                              staticClass: "form-control",
                                              attrs: { type: "number" },
                                              domProps: { value: o.qty },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    o,
                                                    "qty",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c("input", {
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "number",
                                                disabled: "",
                                              },
                                              domProps: {
                                                value:
                                                  Math.round(
                                                    _vm.discountedPrice(o) *
                                                      o.qty *
                                                      100
                                                  ) / 100,
                                              },
                                            }),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c(
                                              "div",
                                              { staticClass: "text-left" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-group mb-0",
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            o.useExpireDateComment,
                                                          expression:
                                                            "o.useExpireDateComment",
                                                        },
                                                      ],
                                                      attrs: {
                                                        type: "checkbox",
                                                        id: `ch_d_${o.supplier.id}`,
                                                      },
                                                      domProps: {
                                                        checked: Array.isArray(
                                                          o.useExpireDateComment
                                                        )
                                                          ? _vm._i(
                                                              o.useExpireDateComment,
                                                              null
                                                            ) > -1
                                                          : o.useExpireDateComment,
                                                      },
                                                      on: {
                                                        change: [
                                                          function ($event) {
                                                            var $$a =
                                                                o.useExpireDateComment,
                                                              $$el =
                                                                $event.target,
                                                              $$c = $$el.checked
                                                                ? true
                                                                : false
                                                            if (
                                                              Array.isArray($$a)
                                                            ) {
                                                              var $$v = null,
                                                                $$i = _vm._i(
                                                                  $$a,
                                                                  $$v
                                                                )
                                                              if (
                                                                $$el.checked
                                                              ) {
                                                                $$i < 0 &&
                                                                  _vm.$set(
                                                                    o,
                                                                    "useExpireDateComment",
                                                                    $$a.concat([
                                                                      $$v,
                                                                    ])
                                                                  )
                                                              } else {
                                                                $$i > -1 &&
                                                                  _vm.$set(
                                                                    o,
                                                                    "useExpireDateComment",
                                                                    $$a
                                                                      .slice(
                                                                        0,
                                                                        $$i
                                                                      )
                                                                      .concat(
                                                                        $$a.slice(
                                                                          $$i +
                                                                            1
                                                                        )
                                                                      )
                                                                  )
                                                              }
                                                            } else {
                                                              _vm.$set(
                                                                o,
                                                                "useExpireDateComment",
                                                                $$c
                                                              )
                                                            }
                                                          },
                                                          function ($event) {
                                                            return _vm.updateDateComment(
                                                              o.supplier.id
                                                            )
                                                          },
                                                        ],
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "pl-2 pointer",
                                                        attrs: {
                                                          for: `ch_d_${o.supplier.id}`,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Комм. срока годности"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                o.useExpireDateComment
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "ml-3 flex",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "mr-1",
                                                          },
                                                          [
                                                            _c("div", [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      o.commentType,
                                                                    expression:
                                                                      "o.commentType",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "form-check-input",
                                                                attrs: {
                                                                  type: "radio",
                                                                  id: `inlineRadio${o.supplier.id}_1`,
                                                                  value: "1",
                                                                },
                                                                domProps: {
                                                                  checked:
                                                                    _vm._q(
                                                                      o.commentType,
                                                                      "1"
                                                                    ),
                                                                },
                                                                on: {
                                                                  change: [
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.$set(
                                                                        o,
                                                                        "commentType",
                                                                        "1"
                                                                      )
                                                                    },
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.updateDateComment(
                                                                        o
                                                                          .supplier
                                                                          .id
                                                                      )
                                                                    },
                                                                  ],
                                                                },
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "form-check-label",
                                                                  attrs: {
                                                                    for: `inlineRadio${o.supplier.id}_1`,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Дата больше"
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("div", [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      o.commentType,
                                                                    expression:
                                                                      "o.commentType",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "form-check-input",
                                                                attrs: {
                                                                  type: "radio",
                                                                  id: `inlineRadio${o.supplier.id}_2`,
                                                                  value: "2",
                                                                },
                                                                domProps: {
                                                                  checked:
                                                                    _vm._q(
                                                                      o.commentType,
                                                                      "2"
                                                                    ),
                                                                },
                                                                on: {
                                                                  change: [
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.$set(
                                                                        o,
                                                                        "commentType",
                                                                        "2"
                                                                      )
                                                                    },
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.updateDateComment(
                                                                        o
                                                                          .supplier
                                                                          .id
                                                                      )
                                                                    },
                                                                  ],
                                                                },
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "form-check-label",
                                                                  attrs: {
                                                                    for: `inlineRadio${o.supplier.id}_3`,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Выбор года"
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("div", [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      o.commentType,
                                                                    expression:
                                                                      "o.commentType",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "form-check-input",
                                                                attrs: {
                                                                  type: "radio",
                                                                  id: `inlineRadio${o.supplier.id}_3`,
                                                                  value: "3",
                                                                },
                                                                domProps: {
                                                                  checked:
                                                                    _vm._q(
                                                                      o.commentType,
                                                                      "3"
                                                                    ),
                                                                },
                                                                on: {
                                                                  change: [
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.$set(
                                                                        o,
                                                                        "commentType",
                                                                        "3"
                                                                      )
                                                                    },
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.updateDateComment(
                                                                        o
                                                                          .supplier
                                                                          .id
                                                                      )
                                                                    },
                                                                  ],
                                                                },
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "form-check-label",
                                                                  attrs: {
                                                                    for: `inlineRadio${o.supplier.id}_3`,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Текст"
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("div", [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  o.expireDateComment,
                                                                expression:
                                                                  "o.expireDateComment",
                                                              },
                                                            ],
                                                            staticClass:
                                                              "form-control",
                                                            attrs: {
                                                              type: "text",
                                                            },
                                                            domProps: {
                                                              value:
                                                                o.expireDateComment,
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                )
                                                                  return
                                                                _vm.$set(
                                                                  o,
                                                                  "expireDateComment",
                                                                  $event.target
                                                                    .value
                                                                )
                                                              },
                                                            },
                                                          }),
                                                        ]),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td"),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              }),
                            ]
                          }
                        ),
                      ],
                      2
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("input", { attrs: { type: "submit", hidden: "" } }),
              ]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Поставщик")]),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Скидка %")]),
        _vm._v(" "),
        _c("th", [_vm._v("Цена")]),
        _vm._v(" "),
        _c("th", [_vm._v("Ц. Скидка")]),
        _vm._v(" "),
        _c("th", [_vm._v("Кол")]),
        _vm._v(" "),
        _c("th", [_vm._v("Сумма")]),
        _vm._v(" "),
        _c("th", { staticClass: "comment_block" }),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }